import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7418d07c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup popup--logout"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "popup__bg" }, null, -1))
const _hoisted_3 = { class: "popup__container" }
const _hoisted_4 = { class: "popup__header" }
const _hoisted_5 = { class: "popup__title h2-like" }
const _hoisted_6 = { class: "popup__content" }
const _hoisted_7 = { class: "popup__block" }
const _hoisted_8 = ["innerHTML"]

import { useApiStore } from "@/stores/apiStore";
import { computed, watch, ref, onBeforeUnmount } from "vue";
import { useI18n } from "vue3-i18n";
import ProgressRing from "./ProgressRing.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LogoutPopup',
  setup(__props) {

const {t} = useI18n()
const apiStore = useApiStore();
const needToLogout = computed(() => apiStore.needToLogout);

watch(needToLogout, () => {
  interval.value = setInterval(() => {
    timeLeftBeforeReturnToHome.value--;

    if (timeLeftBeforeReturnToHome.value == 0) {
      logoutAndRerouteHome();
      clearInterval(interval.value);
    }
  }, 1000);
});

let interval = ref();
const timeLeftBeforeReturnToHome = ref<number>(10);
const percentageLeftBeforeReturnHome = computed(
  () => (timeLeftBeforeReturnToHome.value * 100) / 10
);

function logoutAndRerouteHome() {
  const logoutButton = document.getElementById("js-logout-btn") as HTMLElement;

  if (logoutButton)
    logoutButton.click();

  setTimeout(() => window.location.replace("/"), 1000);
}

onBeforeUnmount(() => {
  if (interval.value != null) {
    clearInterval(interval.value);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (needToLogout.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('global.logout.timeout')), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(ProgressRing, {
                    label: timeLeftBeforeReturnToHome.value,
                    progress: percentageLeftBeforeReturnHome.value,
                    radius: 24,
                    stroke: 3
                  }, null, 8, ["label", "progress"]),
                  _createElementVNode("div", {
                    innerHTML: _unref(t)('global.logout.redirectMessage')
                  }, null, 8, _hoisted_8)
                ]),
                _createElementVNode("button", {
                  class: "popup__btn btn",
                  type: "button",
                  onClick: logoutAndRerouteHome
                }, _toDisplayString(_unref(t)('global.logout.returnHome')), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})